import { render } from "./ZugangTelemedizinLogin.vue?vue&type=template&id=907317d0&scoped=true&ts=true"
import script from "./ZugangTelemedizinLogin.vue?vue&type=script&lang=ts"
export * from "./ZugangTelemedizinLogin.vue?vue&type=script&lang=ts"

import "./ZugangTelemedizinLogin.vue?vue&type=style&index=0&id=907317d0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-907317d0"]])

export default __exports__